function Keyboard(event) {
    this.key_code_map = {
        keypress: {
            49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 48: "0",
            12549: "1", 12553: "2", 711: "3", 715: "4", 12563: "5", 714: "6", 729: "7", 12570: "8", 12574: "9", 12578: "0",
            97: "a", 98: "b", 99: "c", 100: "d", 101: "e", 102: "f", 103: "g", 104: "h", 105: "i", 106: "j", 107: "k", 108: "l", 109: "m",
            110: "n", 111: "o", 112: "p", 113: "q", 114: "r", 115: "s", 116: "t", 117: "u", 118: "v", 119: "w", 120: "x", 121: "y", 122: "z",
            12551: "a", 12566: "b", 12559: "c", 12558: "d", 12557: "e", 12561: "f", 12565: "g", 12568: "h", 12571: "i", 12584: "j", 12572: "k", 12576: "l", 12585: "m",
            12569: "n", 12575: "o", 12579: "p", 12550: "q", 12560: "r", 12555: "s", 12564: "t", 12583: "u", 12562: "v", 12554: "w", 12556: "x", 12567: "y", 12552: "z",
            65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M",
            78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z",
            96: "`", 126: "~",
            33: "!", 64: "@", 35: "#", 36: "$", 37: "%", 94: "^", 38: "&", 42: "*", 40: "(", 41: ")",
            45: "-", 95: "_", 12582: "-",
            61: "=", 43: "+",
            91: "[", 123: "{", 12300: "[",
            93: "]", 125: "}", 12301: "]",
            92: "\\", 124: "|", 12289: "\\",
            34: "\"", 39: "\'", 183: "\'",
            59: ";", 58: ":", 12580: ";",
            47: "/", 63: "?", 12581: "/",
            60: ">", 12577: ">",
            62: "<",12573: "<",
            46: ".",
            44: ",",
            32: " ",
        },
        keydown: {
            49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 48: "0",
            97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 96: "0",
            65: "a", 66: "b", 67: "c", 68: "d", 69: "e", 70: "f", 71: "g", 72: "h", 73: "i", 74: "j", 75: "k", 76: "l", 77: "m",
            78: "n", 79: "o", 80: "p", 81: "q", 82: "r", 83: "s", 84: "t", 85: "u", 86: "v", 87: "w", 88: "x", 89: "y", 90: "z",
            192: "`",
            189: "-",
            187: "=",
            219: "[",
            221: "]",
            220: "\\",
            222: "\'",
            186: ";",
            191: "/",
            190: ".",
            188: ",",
            111: "/", 106: "*", 109: "-", 107: "+", 110: ".",
            32: " ",
        },
        keyup: {
            49: "1", 50: "2", 51: "3", 52: "4", 53: "5", 54: "6", 55: "7", 56: "8", 57: "9", 48: "0",
            97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 96: "0",
            65: "a", 66: "b", 67: "c", 68: "d", 69: "e", 70: "f", 71: "g", 72: "h", 73: "i", 74: "j", 75: "k", 76: "l", 77: "m",
            78: "n", 79: "o", 80: "p", 81: "q", 82: "r", 83: "s", 84: "t", 85: "u", 86: "v", 87: "w", 88: "x", 89: "y", 90: "z",
            192: "`",
            189: "-",
            187: "=",
            219: "[",
            221: "]",
            220: "\\",
            222: "\'",
            186: ";",
            191: "/",
            190: ".",
            188: ",",
            111: "/", 106: "*", 109: "-", 107: "+", 110: ".",
            32: " ",
        },
    }
    this.shift_combined_key_code_map = {
        49: "!", 50: "@", 51: "#", 52: "$", 53: "%", 54: "^", 55: "&", 56: "*", 57: "(", 48: ")",
        65: "A", 66: "B", 67: "C", 68: "D", 69: "E", 70: "F", 71: "G", 72: "H", 73: "I", 74: "J", 75: "K", 76: "L", 77: "M",
        78: "N", 79: "O", 80: "P", 81: "Q", 82: "R", 83: "S", 84: "T", 85: "U", 86: "V", 87: "W", 88: "X", 89: "Y", 90: "Z",
        192: "~",
        189: "_",
        187: "+",
        219: "{",
        221: "}",
        220: "|",
        222: "\"",
        186: ":",
        191: "?",
        190: ">",
        188: "<",
    }
    this.function_key_code_map = {
        0: "SCAN",
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        45: "Insert",
        46: "Delete",
        91: "Meta",
        93: "Menu",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        124: "F13",
        125: "ScrollLock",
    }

    this.event = event;
    this.ctrl = event.ctrlKey;
    this.meta = event.metaKey;
    this.shift = event.shiftKey;
    this.alt = event.altKey;
    this.key = event.key;
    if (event.originalEvent) {
        if (event.originalEvent.code) {
            this.code = event.originalEvent.code
        } else {
            this.code = event.code
        }
    } else {
        this.code = event.code
    }
    this.get_key_code = function() {
        var key_code = null;
        if(window.event) {
            key_code = window.event.keyCode;
        } else if(e) {
            key_code = event.which;
        }
        return key_code;
    }
    this.get_value = function() {
        var key_code = this.get_key_code(event);
        if (event.type == "keypress") {
            return this.key_code_map[event.type][key_code];
        } else {
            if(event.shiftKey) {
                if (event.key == "Shift") {
                    return "";
                } else {
                    return this.shift_combined_key_code_map[key_code];
                }
            } else {
                if (this.key_code_map[event.type][key_code]) {
                    return this.key_code_map[event.type][key_code];
                } else {
                    return "";
                }
            }
        }
    }
    this.key_code = this.get_key_code();
    this.value = this.get_value();
}

module.exports = Keyboard;
